module.exports = __webpack_public_path__ + "static/media/arrow.a084f084.svg";